import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-delete-validator',
  templateUrl: './delete-validator.component.html',
  styleUrls: ['./delete-validator.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DeleteValidatorComponent {

}
